<template>
  <StyledOptionButton
    :href="url"
    :meta="meta"
    :odds="odds"
    :disabled="disabled"
    :buttonId="buttonId"
    :name="name"
    :suspended="suspended"
    :winnings="localisedWinnings"
  />
</template>

<script lang="ts">
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { PropType, defineComponent, computed } from "vue";
import { Option } from "@fresh8/types/src/betData";
import StyledOptionButton from "./styled/OptionButton.vue";
import { formatOdds } from "@fresh8/ad-data-composition/src/lib/formatOdds";
import usePotentialWinnings from "@fresh8/ad-data-composition/src/usePotentialWinnings";
import { oddsTypeEnum } from "@fresh8/types/src";

export default defineComponent({
  name: "OptionButton",
  components: {
    StyledOptionButton
  },
  props: {
    option: { type: Object as PropType<Option>, required: true },
    isDraw: { type: Boolean, required: false, default: false }
  },
  setup(props) {
    const { adTemplate, buttons } = injectBrand() || ({} as BrandContext);
    const buttonId = computed(
      () =>
        adTemplate.value?.market?.oddsButton ||
        (buttons.value && Object.keys(buttons.value)[0]) ||
        ""
    );

    const odds = computed(
      () =>
        (props.option &&
          formatOdds(
            props.option.odds,
            adTemplate.value?.market.oddsButtonTemplate ||
              oddsTypeEnum.FRACTIONAL_ODDS
          )) ||
        "-"
    );

    const { localisedWinnings } = usePotentialWinnings(props.option.odds);

    return {
      suspended: props.option?.suspended,
      odds,
      localisedWinnings,
      name: props.option.name.short,
      meta: props.option?.meta,
      url: props.option?.betslipUrl,
      disabled: !props.option || props.option?.suspended,
      buttonId
    };
  }
});
</script>

<style></style>
